export const configuration = {
  API_URL: window.ENV.API_URL,
  API_KEY: window.ENV.API_KEY,
  GOOGLE_API_KEY: window.ENV.GOOGLE_API_KEY,
  CURRENT_YEAR: window.ENV.CURRENT_YEAR,
  SHOW_REGISTRATION: window.ENV.SHOW_REGISTRATION || false,
};
